import { getAppVersion } from '../sessionStorage'
import { isDevEnvironment } from '../utils'

/** Set before release when native ships UPI intent bridge + OTP packageName support. */
export const MIN_APP_VERSION_UPI_INTENTS = 81

function getNumericAppVersion(): number | null {
  const rawVersion = getAppVersion()
  if (rawVersion === '' || rawVersion == null) {
    return null
  }
  const version = Number(rawVersion)
  if (!Number.isFinite(version)) {
    return null
  }
  return version
}

export function isUpiIntentsFlowEnabled(): boolean {
  // Lets v2 autopay + UPI intent flows run in browser/MSW without a native build ≥ v81.
  if (isDevEnvironment()) {
    return true
  }

  const appVersion = getNumericAppVersion()
  if (appVersion === null) {
    return false
  }
  return appVersion >= MIN_APP_VERSION_UPI_INTENTS
}
